import React, { useContext, useEffect, useState } from 'react';
import { getConfig } from '@zimpel/common/config';
import { reloadCurrentPage } from '@zimpel/common/helpers/browser';
import t from '@zimpel/common/helpers/i18n';
import { ModalContext } from './common/components/Dialogue/Dialogue';

const useReloadNewAppVersion = () => {
  const { appVersion } = getConfig();

  const [newAppVersion, setNewAppVersion] = useState(appVersion);
  const { alert } = useContext(ModalContext);

  useEffect(() => {
    const eventListener = ((event: CustomEvent<string>) => { setNewAppVersion(event.detail); }) as EventListener;
    window.addEventListener('newAppVersion', eventListener);
    return () => {
      window.removeEventListener('newAppVersion', eventListener);
    };
  }, []);

  useEffect(() => {
    if (newAppVersion !== appVersion) {
      alert(t('reload_new_version_dialog')).then(() => reloadCurrentPage());
    }
  }, [newAppVersion, appVersion]);
};

export default useReloadNewAppVersion;

export const ReloadWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  useReloadNewAppVersion();

  return <>{children}</>;
};
